import { isAssertionResult } from './assertion';
import { map } from './commons';
const flatten = map(m => {
    m.offset = 0;
    return m;
});
const print = (message, offset = 0) => {
    console.log(message.padStart(message.length + (offset * 4))); // 4 white space used as indent (see tap-parser)
};
const stringifySymbol = (key, value) => {
    if (typeof value === 'symbol') {
        return value.toString();
    }
    return value;
};
const printYAML = (obj, offset = 0) => {
    const YAMLOffset = offset + 0.5;
    print('---', YAMLOffset);
    for (const [prop, value] of Object.entries(obj)) {
        print(`${prop}: ${JSON.stringify(value, stringifySymbol)}`, YAMLOffset + 0.5);
    }
    print('...', YAMLOffset);
};
const comment = (value, offset) => {
    print(`# ${value}`, offset);
};
const subTestPrinter = (prefix = '') => (message) => {
    const { data } = message;
    const value = `${prefix}${data.description}`;
    comment(value, message.offset);
};
const indentedSubTest = subTestPrinter('Subtest: ');
const flatSubTest = subTestPrinter();
const testEnd = (message) => {
    const length = message.data.length;
    const { offset } = message;
    print(`1..${length}`, offset);
};
const bailOut = (message) => {
    print('Bail out! Unhandled error.');
};
const indentedDiagnostic = ({ expected, pass, description, actual, operator, at = 'N/A', ...rest }) => ({
    wanted: expected,
    found: actual,
    at,
    operator,
    ...rest
});
const flatDiagnostic = ({ pass, description, ...rest }) => rest;
const indentedAssertion = (message, idIter) => {
    const { data, offset } = message;
    const { pass, description } = data;
    const label = pass === true ? 'ok' : 'not ok';
    const { value: id } = idIter.next();
    if (isAssertionResult(data)) {
        print(`${label} ${id} - ${description}`, offset);
        if (pass === false) {
            printYAML(indentedDiagnostic(data), offset);
        }
    }
    else {
        const comment = data.skip === true ? 'SKIP' : `${data.executionTime}ms`;
        print(`${pass ? 'ok' : 'not ok'} ${id} - ${description} # ${comment}`, message.offset);
    }
};
const flatAssertion = (message, idIter) => {
    const { data, offset } = message;
    const { pass, description } = data;
    const label = pass === true ? 'ok' : 'not ok';
    if (isAssertionResult(data)) {
        const { value: id } = idIter.next();
        print(`${label} ${id} - ${description}`, offset);
        if (pass === false) {
            printYAML(flatDiagnostic(data), offset);
        }
    }
    else if (data.skip) {
        const { value: id } = idIter.next();
        print(`${pass ? 'ok' : 'not ok'} ${id} - ${description} # SKIP`, offset);
    }
};
const indentedReport = (message, id) => {
    switch (message.type) {
        case "TEST_START" /* TEST_START */:
            id.fork();
            indentedSubTest(message);
            break;
        case "ASSERTION" /* ASSERTION */:
            indentedAssertion(message, id);
            break;
        case "TEST_END" /* TEST_END */:
            id.merge();
            testEnd(message);
            break;
        case "BAIL_OUT" /* BAIL_OUT */:
            bailOut(message);
            throw message.data;
    }
};
const flatReport = (message, id) => {
    switch (message.type) {
        case "TEST_START" /* TEST_START */:
            flatSubTest(message);
            break;
        case "ASSERTION" /* ASSERTION */:
            flatAssertion(message, id);
            break;
        case "BAIL_OUT" /* BAIL_OUT */:
            bailOut(message);
            throw message.data;
    }
};
const summary = (harness) => {
    print('', 0);
    comment(harness.pass ? 'ok' : 'not ok', 0);
    comment(`success: ${harness.successCount}`, 0);
    comment(`skipped: ${harness.skipCount}`, 0);
    comment(`failure: ${harness.failureCount}`, 0);
};
const id = function* () {
    let i = 0;
    while (true) {
        yield ++i;
    }
};
const idGen = () => {
    let stack = [id()];
    return {
        [Symbol.iterator]() {
            return this;
        },
        next() {
            return stack[0].next();
        },
        fork() {
            stack.unshift(id());
        },
        merge() {
            stack.shift();
        }
    };
};
export const tapeTapLike = async (stream) => {
    const src = flatten(stream);
    const id = idGen();
    print('TAP version 13');
    for await (const message of src) {
        flatReport(message, id);
    }
    print(`1..${stream.count}`, 0);
    summary(stream);
};
export const mochaTapLike = async (stream) => {
    print('TAP version 13');
    const id = idGen();
    for await (const message of stream) {
        indentedReport(message, id);
    }
    summary(stream);
};
